import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from '../config/config'; // Importing development configuration

/**
 * Class representing the marketing view.
 * @extends JetView
 */
export default class marketingView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        return {}; // Returns an empty configuration object
    }

    /**
     * Initializes the view.
     * Opens a new window and redirects after a delay.
     */
    init() {
        // Opens a new window with the marketing URL and token from local storage
        window.open('/marketing?tt=' + localStorage.getItem('x-token'), '_blank');
        // Delays the redirection to the dashboard by 1000 milliseconds
        webix.delay(
            function () {
                location.href = '/#!/top/dashboard'; // Redirects to the dashboard
            },
            '',
            '',
            1000,
        );
    }
}

// FILE DOCUMENTED
